<template>
    <div>
        <b-table
            :empty-text="$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="reimbursementForms"
            :fields="fields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded"
        >
            <template #cell(actions)="data">
                <b-dropdown
                    no-caret
                    right
                    variant="link"
                    toggle-class="p-0 text-muted"
                >
                    <template #button-content>
                        <i class="ri-more-fill"></i>
                    </template>

                    <b-dropdown-item
                        v-if="checkPermission('reimbursementform_myrequestshow')"
                        @click="$router.push('/my-staff-requests/reimbursement/' + data.item.id)"
                    >
                        <i class="ri-eye-line mr-2 text-primary"></i>{{ $t('detail') }}
                    </b-dropdown-item>
                    <b-dropdown-item
                        v-if="checkPermission('reimbursementform_myrequestapprovalstepsreport')"
                        @click="downloadApprovalStepsReport(data.item.id)"
                    >
                        <i class="ri-file-pdf-line mr-2 text-danger"></i>{{ $t('approval_steps_report') }}
                    </b-dropdown-item>
                </b-dropdown>
            </template>

            <!-- Requester -->
            <template #cell(requester)="data">
                {{ data.item.full_name }}
            </template>

            <!-- Job Title -->
            <template #cell(job_title_name)="data">
                {{ data.item.job_title_name|| '-' }}
            </template>

            <!-- Grand Total -->
            <template #cell(grand_total)="data">
                {{ currencyFormat(data.item.grand_total) }}
            </template>

            <!-- Active Step -->
            <template #cell(active_step)="data">
                {{ data.item.active_step ? data.item.active_step.name : '-' }}
            </template>
        </b-table>
    </div>
</template>

<script>
import ReimbursementFormService from "@/services/ReimbursementFormService";
import qs from "qs";

export default {
    name: "ReimbursementForm",
    props: {
        filter: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            reimbursementForms: [],
            fields: [
                { key: "actions", label: "", tdClass: "text-center" },
                { key: "requester", label: this.toUpperCase("requester") },
                { key: "employee_id", label: this.toUpperCase("employee_id") },
                { key: "job_title_name", label: this.toUpperCase("job_title") },
                { key: "budgetary_department_name", label: this.toUpperCase("budgetary_department") },
                { key: "grand_total", label: this.toUpperCase("total_amount"), thClass: "text-right", tdClass: "text-right" },
                { key: "status_name", label: this.toUpperCase("status") },
                { key: "active_step", label: this.toUpperCase("approval_stage") },
                { key: "last_approve_date", label: this.toUpperCase("date_approval_sent") },
            ],
            itemFields: [
                { key: "item_name", label: this.toUpperCase("item_name") },
                { key: "price_per_unit", label: this.toUpperCase("price_per_unit"), thClass: "text-right", tdClass: "text-right" },
                { key: "quantity", label: this.toUpperCase("quantity"), thClass: "text-center", tdClass: "text-center" },
            ],
        };
    },
    created() {
        this.getData();
    },
    methods: {
        async getData() {
            const config = {
                ...this.filter,
                paramsSerializer: (params) => qs.stringify(params, { encode: false }),
            };
            try {
                const response = await ReimbursementFormService.getMyRequests(config);
                this.reimbursementForms = response.data.data;
            } catch (e) {
                this.showErrors(e);
            }
        },
        downloadApprovalStepsReport(id) {
            ReimbursementFormService.getMyRequestApprovalStepsReport(id)
                .then((response) => {
                    this._downloadFile(response, `approval-steps-report-${id}.pdf`);
                })
                .catch((error) => {
                    this.showErrors(error);
                });
        },
    },
};
</script>
